import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TheHouse from './components/TheHouse';
import TheCollection from './components/TheCollection';
import TheScentStory from './components/TheScentStory';
import WhyMaisonVael from './components/WhyMaisonVael';
import ShopPreview from './components/ShopPreview';
import ContactOrder from './components/ContactOrder';
import Footer from './components/Footer';
import ScentQuiz from './components/ScentQuiz';

import { registerScrollTrigger } from './lib/motion';

registerScrollTrigger();

function App() {
  return (
    <div style={{ background: 'var(--black)', color: 'var(--cream)', overflowX: 'hidden' }}>
      <a href="#house" className="skip-link">Skip to content</a>
      <Navbar />
      <main id="main">
        <Hero />
        <TheHouse />
        <TheCollection />
        <TheScentStory />
        <WhyMaisonVael />
        <ShopPreview />
        <ContactOrder />
      </main>
      <Footer />
      <ScentQuiz />
    </div>
  );
}

export default App;
